import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "imageDropSpace" }
const _hoisted_2 = { class: "dragSpace" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "drag-drop",
        onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
        onDrop: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dropImage && _ctx.dropImage(...args)), ["prevent"])),
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args)))
      }, [
        _createElementVNode("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _cache[4] || (_cache[4] = _createTextVNode("Trascina le immagini ")),
            _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
            _cache[6] || (_cache[6] = _createTextVNode(" o clicca qui"))
          ], true)
        ]),
        _createElementVNode("input", {
          type: "file",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileSelect && _ctx.onFileSelect(...args))),
          ref: "fileInput",
          class: "hidden absolute",
          multiple: "true"
        }, null, 544)
      ], 32)
    ])
  ]))
}